export const OTP_EMAIL_STORAGE_KEY = "otpEmail";
export const OTP_STATE_HANDLE_STORAGE_KEY = "otpStateHandle";
/** Persisted before navigate to activation so the page reads the correct mode immediately. */
export const OTP_VERIFICATION_MODE_KEY = "otpVerificationMode";

export function getInitialMode(): "signIn" | "signUp" {
  try {
    return sessionStorage.getItem(OTP_VERIFICATION_MODE_KEY) === "signIn"
      ? "signIn"
      : "signUp";
  } catch {
    return "signUp";
  }
}

export function setOtpEmailStorage(email: string): void {
  try {
    sessionStorage.setItem(OTP_EMAIL_STORAGE_KEY, email);
  } catch {
    // ignore
  }
}

export function setOtpStateHandleStorage(stateHandle: string): void {
  try {
    sessionStorage.setItem(OTP_STATE_HANDLE_STORAGE_KEY, stateHandle);
  } catch {
    // ignore
  }
}

export function setOtpVerificationModeStorage(mode: "signIn" | "signUp"): void {
  try {
    sessionStorage.setItem(OTP_VERIFICATION_MODE_KEY, mode);
  } catch {
    // ignore
  }
}

export function clearOtpStorage(): void {
  try {
    sessionStorage.removeItem(OTP_EMAIL_STORAGE_KEY);
    sessionStorage.removeItem(OTP_STATE_HANDLE_STORAGE_KEY);
    sessionStorage.removeItem(OTP_VERIFICATION_MODE_KEY);
  } catch {
    // ignore
  }
}
